import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Card, Grid, Icon, Image } from "semantic-ui-react";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import UiMeet3dLink from "~/models/UiMeet3d/UiMeet3dLink";
import UiMeet3dLinkRole from "~/constants/UiMeet3d/UiMeet3dLinkRole";
import Clipboard from "~/applications/panel/components/Clipboard";
import QrCodeHelper from "~/utils/QrCodeHelper";
import "../styles/UiMeet3dLinkCard.less";

const UiMeet3dLinkCard = observer(({ uiMeet3dLink, t, defaultPhotoPathWeb, defaultLogoPathWeb }) => (
  <Card className="ui-meet-3d-link-card" fluid>
    <Card.Content>
      <Card.Header>
        {uiMeet3dLink.role === UiMeet3dLinkRole.AGENT ? (
          <>
            <Icon name="user circle" /> {t("clientPanelMisc:organizer")}
          </>
        ) : (
          <>
            <Icon name="users" /> {t("clientPanelMisc:visitors")}
          </>
        )}
      </Card.Header>
    </Card.Content>
    <Card.Content>
      <a href={uiMeet3dLink.shortUrl} target="_blank" rel="noopener noreferrer">
        {uiMeet3dLink.shortUrl}
      </a>
      <Clipboard
        className="copy-url-clipboard"
        data={uiMeet3dLink.shortUrl}
        animationTime={2000}
        contentPopup={t("copyURLClipboard")}
        inverted={false}
      />
      <Button
        className="qr-code-button"
        size="small"
        icon
        as="a"
        title={t("QR")}
        href={QrCodeHelper.makeQueryQrCode(uiMeet3dLink.shortUrl)}
        target="_blank"
        rel="noreferrer"
      >
        <Icon name="qrcode" color="black" />
      </Button>
    </Card.Content>
    {(uiMeet3dLink.name || uiMeet3dLink.email) && (
      <Card.Content>
        {uiMeet3dLink.name && (
          <p>
            <strong>{t("name")}:</strong> {uiMeet3dLink.name}
          </p>
        )}
        {uiMeet3dLink.email && (
          <p>
            <strong>{t("email")}:</strong> {uiMeet3dLink.email}
          </p>
        )}
      </Card.Content>
    )}
    {uiMeet3dLink.role !== UiMeet3dLinkRole.AGENT && (
      <Card.Content>
        {!uiMeet3dLink.isGuidedTourMode ? <Icon name="check" color="green" /> : <Icon name="close" color="red" />}
        {t("clientPanelMisc:allowedToTurnOnVideoAndAudio")}
      </Card.Content>
    )}
    {uiMeet3dLink.role === UiMeet3dLinkRole.AGENT &&
      uiMeet3dLink.usePhotos &&
      (uiMeet3dLink.photoPathWeb || defaultPhotoPathWeb || uiMeet3dLink.logoPathWeb || defaultLogoPathWeb) && (
        <Card.Content>
          <Grid columns="equal">
            {(uiMeet3dLink.photoPathWeb || defaultPhotoPathWeb) && (
              <Grid.Column>
                <p>
                  <strong>{t("clientPanelMisc:avatar")}</strong>
                </p>
                <Image size="small" src={uiMeet3dLink.photoPathWeb || defaultPhotoPathWeb} />
              </Grid.Column>
            )}
            {(uiMeet3dLink.logoPathWeb || defaultLogoPathWeb) && (
              <Grid.Column>
                <p>
                  <strong>{t("clientPanelMisc:backBadge")}</strong>
                </p>
                <Image size="small" src={uiMeet3dLink.logoPathWeb || defaultLogoPathWeb} />
              </Grid.Column>
            )}
          </Grid>
        </Card.Content>
      )}
  </Card>
));

UiMeet3dLinkCard.propTypes = {
  t: PropTypes.func.isRequired,
  uiMeet3dLink: PropTypes.instanceOf(UiMeet3dLink),
  defaultPhotoPathWeb: PropTypes.string,
  defaultLogoPathWeb: PropTypes.string,
};

export default withTranslation()(ErrorWrapper(UiMeet3dLinkCard));
